export default "__VITE_ASSET__a1bc1db9__"